import React from 'react';

import Shimmer from 'components/Shimmer';

import Details from '../Details';
import {
  Card,
  Header,
  Info,
  Section,
  Traveler,
  UserLabel,
  Title,
  Price,
  Destination,
  DestinationDetail,
} from '../styles';

const LoaderCard = () => (
  <Card>
    <Header>
      <Info>
        <Title>
          <Shimmer>Rappi Code: 99999999</Shimmer>
        </Title>
      </Info>
      <Shimmer>Expired</Shimmer>
    </Header>

    <Section>
      <div>
        <Traveler>
          <Shimmer>User name</Shimmer>
        </Traveler>
        <UserLabel>
          <Shimmer>Group name</Shimmer>
        </UserLabel>
      </div>
      <Price>
        <Shimmer>99.999 COP</Shimmer>
      </Price>
    </Section>

    <Section>
      <div>
        <Destination>
          <Shimmer>Miami</Shimmer>
        </Destination>
        <DestinationDetail>
          <Shimmer>Fri, 08 Aug</Shimmer> - <Shimmer>Sun, 10 Aug</Shimmer>
        </DestinationDetail>
        <DestinationDetail>
          <Shimmer>2 days</Shimmer>
        </DestinationDetail>
      </div>
    </Section>
    <Details open={false} isLoading={true} outOfPolicy={false} onToggle={() => {}}>
      <Shimmer>Details</Shimmer>
    </Details>
  </Card>
);

export default LoaderCard;
